import { Component, OnInit, AfterViewInit,Input, SimpleChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";
import { bloomAdd } from '@angular/core/src/render3/di';

@Component({
  selector: 'app-cqmns-ga-usersummary',
  templateUrl: './cqmns-ga-usersummary.component.html',
  styleUrls: ['./cqmns-ga-usersummary.component.css']
})
export class CqmnsGaUsersummaryComponent implements OnInit {

  @Input() viewId: any;
  projects: any;
  projectId: any;
  gadatausers: any;
  hostUrl;
  userdate: any;
  userscount: any;
  ctxgausersum: any;
  canvasgausersum: any;
  myChartgausersum: any;
  ctxgabouncesum: any;
  canvasgabouncesum: any;
  myChartgasessionsum: any;
  ctxgasessionsum: any;
  canvasgasessionsum: any;
  myChartgabouncesum: any;
  gauserssum: any = [];
  bouncesum: any = [];
  sessionsum: any = [];
  date: any;
  myChartgausers: any;
  myChartgausergaUser: any;
  selectedduration: any;
  valuesum = 'Users';
  duration: any;
  gadata: any;
  User: any;
  SessionDuration: any;
  BounceRate: any;
  val1:any;
  val2: any;
  value1: any;
  value2: any;
  value3: any;
  
  ctxgauser: any;
  canvasgauser: any;
  myChartgauser: any;
  ctxgauser1: any;
  canvasgauser1: any;
  myChartgauser1: any;
  gausers: any = [];
  classificationsgausers = [];
  noOfclassificationsgausers = [];
  labels: any = [];
  data: any = [];
  gausers2: any;
  gausers1:any;
  myChartgauser2: any;
  canvasgauser2: any;
  ctxgauser2: any;
  selectedIndex: any;
  viewIdApi: any;
  hideDash: boolean;
  userId:any;
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private userService: UserService, private authService: AuthService, 
  ) {}

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hideDash = false;
    console.log('valueeeeeeee',this.viewId)
    this.hostUrl = this.userService.getUrl();
    this.userId = localStorage.getItem("userid");

   // this.projectId = this.route.snapshot.params["projectId"];
    this.projectId = localStorage.getItem("projectId");
    
  }
    ngOnChanges(changes:SimpleChanges){
        this.hideDash = true;
        this.viewIdApi = changes.viewId.currentValue;
        if(this.viewIdApi){
        this.getUserSummary()
        this.ngAfterViewInit ();
        this.getSummary()
        }
      } 
  ngAfterViewInit (){
  this.updateUserChart();
  this.updateBounceChart();
  this.updateSessionChart();
  }
  onchange(value1) {
    this.value1 = value1;
    if (this.value1 === "val07") {
      console.log('val7')
      this.duration = '7'
    }
       else if(this.value1 === "val28")
      {
        console.log('val28')
        this.duration = '28'
      }else if(this.value1 === "val90"){
        console.log('val90')
        this.duration = '90'
      }
      this.http
    .get(
      encodeURI(
        this.hostUrl +
          "/api/issue/userAndDateCountbyGoogleAnalytics/" +
          this.projectId +
          "/" +this.duration + "/" +  this.viewIdApi
      )
    )
    .subscribe(data => {
      this.gauserssum = data;
      if (this.myChartgausersum) {
        this.myChartgausersum.destroy();
      }
      this.updateUserChart();
      this.updateChartgaUsersum(this.myChartgausersum)
    });
  }
  onchangeBounce(value2) {
    this.value2 = value2;
    if (this.value2 === "val07") {
      this.duration = '7'
    }
       else if(this.value2 === "val28")
      {
        this.duration = '28'
      }else if(this.value2 === "val90"){
        this.duration = '90'
      }
      this.http
    .get(
      encodeURI(
        this.hostUrl +
          "/api/issue/bounceAndDateCountbyGoogleAnalytics/"  +
          this.projectId
         +
          "/" +this.duration + "/" +  this.viewIdApi
      )
    )
    .subscribe(data => {
      this.bouncesum = data;  
      if (this.myChartgabouncesum) {
        this.myChartgabouncesum.destroy();
      }
      this.updateBounceChart();
      this.updateChartgaBouncesum(this.myChartgabouncesum)
    });
    
  }
  onchangeSession(value3) {
    this.value3 = value3;
    if (this.value3 === "val07") {
      this.duration = '7'
    }
       else if(this.value3 === "val28")
      {
        this.duration = '28'
      }else if(this.value3 === "val90"){
        this.duration = '90'
      }
      this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/sessionDurationAndDateCountbyGoogleAnalytics/" +
           this.projectId
          +
          "/" +this.duration + "/" +  this.viewIdApi
         
        )
      )
      .subscribe(data => {
        this.sessionsum = data; 
        if (this.myChartgasessionsum) {
          this.myChartgasessionsum.destroy();
        }
        this.updateSessionChart(); 
        this.updateChartgaSessionsum(this.myChartgasessionsum)
  
      });
  }

  getSummary(){
    this.http
    .get(
      encodeURI(
        this.hostUrl + "/api/issue/sessioncountbyGoogleAnalytics/" + this.projectId + "/" +  this.viewIdApi
      )
    )
    .subscribe(data => {
      this.gadata = data;
      this.User = this.gadata.User;
      this.SessionDuration = this.gadata.SessionDuration;
      this.BounceRate = this.gadata.BounceRate;
      let stringToSplit = this.SessionDuration;
      let x = stringToSplit.split(".");
      this.val1 = x[0];
      this.val2 = x[1];      
    }); 
  }
  getUserSummary()
  {
    this.http
    .get(
      encodeURI(
        this.hostUrl +
          "/api/issue/userAndDateCountbyGoogleAnalytics/" +
          this.projectId +
          "/7" + "/" +  this.viewIdApi
      )
    )
    .subscribe(data => {
      this.gauserssum = data;
      if (this.myChartgausersum) {
        this.myChartgausersum.destroy();
      }
      this.updateUserChart();
      this.updateChartgaUsersum(this.myChartgausersum)
    });
    
    this.http
    .get(
      encodeURI(
        this.hostUrl + "/api/issue/bounceAndDateCountbyGoogleAnalytics/" +this.projectId +
        "/7" + "/" +  this.viewIdApi
      )
    )
    .subscribe(data => {
      this.bouncesum = data;  
      if (this.myChartgabouncesum) {
        this.myChartgabouncesum.destroy();
      }
      this.updateBounceChart();
      this.updateChartgaBouncesum(this.myChartgabouncesum)

    });
    this.http
    .get(
      encodeURI(
        this.hostUrl + "/api/issue/sessionDurationAndDateCountbyGoogleAnalytics/" + this.projectId +
        "/7"  + "/" + this.viewIdApi
      )
    )
    .subscribe(data => {
      this.sessionsum = data;  
      if (this.myChartgasessionsum) {
        this.myChartgasessionsum.destroy();
      }
      this.updateSessionChart(); 
      this.updateChartgaSessionsum(this.myChartgasessionsum)

    });
  }
  changechart(val){
  this.valuesum = val;
  }
  updateUserChart() {

    Chart.defaults.global.defaultFontColor = "#000";
    this.canvasgausersum = document.getElementById("myChartgausersum");
    this.ctxgausersum = this.canvasgausersum.getContext("2d");
    this.myChartgausersum = new Chart(this.ctxgausersum, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "Users",
            borderColor: "#67b2c7",
            borderWidth: 2,
             fill: false,
             lineTension: 0,
        borderJoinStyle: 'miter',
          }
        ]
      },
   
      options: {
        title: {
          display: true,
          text: 'Users',
          fontColor: "#5f7388",
          fontSize: 15
      },
        responsive: true, // for chart resize after update issue
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display:false
            },
            scaleLabel: {
              display: true,
              labelString: 'Day',
              fontFamily: 'verdana',
              fontSize: 12
            },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 6,
                stepSize: 0.2
              },
              // autoSkip: false,
              display: true,
              type: "time",
              time: {
                parser: "YYYYMMDD",
                unit: "day",
                unitStepSize: 1,
                tooltipFormat: "MMM DD YYYY",
                displayFormats: {
                  day: "MMM DD"
                }
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
               display:true
            },
            scaleLabel: {
              display: true,
              labelString: 'User Count',
              fontFamily: 'verdana',
              fontSize: 12,
             
            },
              ticks: {
                beginAtZero: true,
                userCallback: function(label, index, labels) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                      return label;
                  }

              },
              }
            }
          ]
        }
      }
    });
  }
    updateBounceChart() {
    this.canvasgabouncesum = document.getElementById("myChartgabouncesum");
    this.ctxgabouncesum = this.canvasgabouncesum.getContext("2d");
    this.myChartgabouncesum = new Chart(this.ctxgabouncesum, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "Bounce Rate",
            borderColor: "#67b2c7",
            borderWidth: 2,
             fill: false,
             lineTension: 0,
        borderJoinStyle: 'miter',
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Bounce Rate',
          fontColor: "#5f7388",
          fontSize: 15
      },
        responsive: true, // for chart resize after update issue
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display:false
             },
             scaleLabel: {
              display: true,
              labelString: 'Day',
              fontFamily: 'verdana',
              fontSize: 12
            },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 6,
                stepSize: 0.2
              },
              // autoSkip: false,
              display: true,
              type: "time",
              time: {
                parser: "YYYYMMDD",
                unit: "day",
                unitStepSize: 1,
                tooltipFormat: "MMM DD YYYY",
                displayFormats: {
                  day: "MMM DD"
                }
              }
            }
          ],
          yAxes: [
            { 
              gridLines: {
              display:true
           },
           scaleLabel: {
            display: true,
            labelString: 'Bounce Rate (%)',
            fontFamily: 'verdana',
            fontSize: 12,
           
          },
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    });
  }
  updateSessionChart() {
    this.canvasgasessionsum = document.getElementById("myChartgasessionsum");
    this.ctxgasessionsum = this.canvasgasessionsum.getContext("2d");
    this.myChartgasessionsum = new Chart(this.ctxgasessionsum, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "Session Duration",
            borderColor: "#67b2c7",
            borderWidth: 2,
             fill: false,
             lineTension: 0,
        borderJoinStyle: 'miter',
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Session Duration',
          fontColor: "#5f7388",
          fontSize: 15
      },
        responsive: true, // for chart resize after update issue
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display:false
             },
             scaleLabel: {
              display: true,
              labelString: 'Day',
              fontFamily: 'verdana',
              fontSize: 12
            },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 6,
                stepSize: 0.2
              },
              // autoSkip: false,
              display: true,
              type: "time",
              time: {
                parser: "YYYYMMDD",
                unit: "day",
                unitStepSize: 1,
                tooltipFormat: "MMM DD YYYY",
                displayFormats: {
                  day: "MMM DD"
                }
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display:true
             },
             scaleLabel: {
              display: true,
              labelString: 'Session Duration (msec)',
              fontFamily: 'verdana',
              fontSize: 12,
             
            },
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    });
  }
  
  updateChartgaUsersum(myTrendsum) {
 
    for (let i = 0; i < this.gauserssum.length; i++) {
      myTrendsum.data.labels.push(this.gauserssum[i].date);
      myTrendsum.data.datasets[0].data.push(this.gauserssum[i].user);
    }
    myTrendsum.update();
  }
  updateChartgaBouncesum(myTrendsum) {
    for (let i = 0; i < this.bouncesum.length; i++) {
      myTrendsum.data.labels.push(this.bouncesum[i].date);
      myTrendsum.data.datasets[0].data.push(this.bouncesum[i].bounceRate);
    }
    myTrendsum.update();
  }
  updateChartgaSessionsum(myTrendsum) {
    for (let i = 0; i < this.sessionsum.length; i++) {
      myTrendsum.data.labels.push(this.sessionsum[i].date);
      myTrendsum.data.datasets[0].data.push(this.sessionsum[i].sessionDuration);
    }
    myTrendsum.update();
  }

}






// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-analytics/cqmns-ga-usersummary/cqmns-ga-usersummary.component.ts